/**
 * Single source of truth for plan display metadata (name/price/features)
 * consumed by both Subscription.js (plan grid) and Checkout.js (checkout
 * summary) — avoids the same price/name/feature strings drifting apart
 * across components.
 *
 * The ACTUAL price the user is charged is never taken from here — it is
 * always recomputed server-side from PLAN_PRICES in server/routes/payments.js
 * (server/routes/payments.js:20-23), independent of anything the client
 * sends or displays. This file is display-only.
 */
export const PLANS = [
  {
    key: "free",
    name: "Cvanto Free",
    price: "0 грн",
    subtitle: "Для всіх",
    description: "Базовий доступ до Cvanto.",
    features: [
      "Оголошення",
      "Пости",
      "Чати",
      "Спільноти",
      "1 активна сторіс",
      "Базовий профіль",
      "Є реклама",
    ],
  },
  {
    key: "plus",
    name: "Cvanto Plus",
    price: "149 грн/міс",
    subtitle: "Комфорт без зайвого шуму",
    description: "Для користувачів, які хочуть більше зручності.",
    features: [
      "Все з Free",
      "Без зовнішньої реклами",
      "До 5 активних сторіс",
      "Бейдж Plus",
      "Базова статистика",
      "Пріоритет у підтримці",
      "Більше лімітів",
    ],
  },
  {
    key: "business",
    name: "Cvanto Business",
    price: "249 грн/міс",
    subtitle: "Для тих, хто заробляє через Cvanto",
    description: "Бізнес-набір для продажів, послуг і просування.",
    features: [
      "Все з Plus",
      "Бізнес-вітрина",
      "Модулі профілю",
      "Каталог",
      "Онлайн-запис",
      "Вакансії",
      "Команда",
      "Доставка",
      "Сертифікати",
      "Карта і графік",
      "Відгуки",
      "Статистика бізнесу",
      "Кабінет реклами",
    ],
  },
];

export function getPlanByKey(key) {
  return PLANS.find((p) => p.key === key) || null;
}
